import { render, staticRenderFns } from "./messageAll.vue?vue&type=template&id=8531a34e&scoped=true&"
import script from "./messageAll.vue?vue&type=script&lang=js&"
export * from "./messageAll.vue?vue&type=script&lang=js&"
import style0 from "./messageAll.vue?vue&type=style&index=0&id=8531a34e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531a34e",
  null
  
)

export default component.exports